module.exports = __webpack_public_path__ + "media/music/piano_chords_9-f3c99a2e.mp3";